<template>
	<div class="sub-values">
		<div class="sub-value">
			<div class="label">Stundensatz</div>
			<div>
				<template v-if="data && data.hourlyRate">{{ data.hourlyRate }} &euro;</template>
				<template v-else>Egal</template>
			</div>
		</div>
	</div>
</template>

<script>
export default {

	props: {
		job: {
			type: Object,
			required: true,
		},
		data: {
			type: Object,
			required: false,
		},
	},
}
</script>
